import { createI18n } from 'vue-i18n'
import { App } from '@/common/constant'
/**
 * Load locale messages
 *
 * The loaded JSON locale messages is pre-compiled by @intlify/vue-i18n-loader, which is integrated into vue-cli-plugin-i18n.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages (appName) {
  const messages = {}
  let context = null

  switch (appName) {
    case App.Account:
      context = require.context('./locales', true, /[A-Za-z0-9-_]+\/(common|account)\/[A-Za-z0-9-_]+.js$/i)
      break
    case App.Teacher:
      context = require.context('./locales', true, /[A-Za-z0-9-_]+\/(common|teacher)\/[A-Za-z0-9-_]+.js$/i)
      break
    case App.Student:
      context = require.context('./locales', true, /[A-Za-z0-9-_]+\/(common|student)\/[A-Za-z0-9-_]+.js$/i)
      break
  }

  if (context) {
    const keys = context.keys()

    for (let i = 0; i < keys.length; i++) {
      const matched = keys[i].match(/[a-zA-Z-]+/)

      if (matched && matched.length > 0) {
        const locale = matched[0]
        const message = context(keys[i]).default

        messages[locale] = { ...messages[locale], ...message }
      }
    }
  }

  return messages
}

export default createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'vi',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'vi',
  // messages: loadLocaleMessages(),
  globalInjection: true
})

export { loadLocaleMessages }
